import { component } from 'picoapp';

class LanguageSelect {
  constructor({ wrapper }) {
    this.icon = wrapper.querySelector('.js-icon');
    this.select = wrapper.querySelector('.js-select');

    this.init = this.init.bind(this);
    this.populate = this.populate.bind(this);
    this.change = this.change.bind(this);

    this.init();
  }

  populate() {
    window.theme.stores.forEach((store) => {
      const option = document.createElement('option');
      option.value = store.prettyUrl || store.url;
      option.textContent = store.title;

      this.select.appendChild(option);

      if (store.title === window.theme.currentStore) {
        option.selected = true;

        const iconImg = document.createElement('img');
        iconImg.src = store.icon;
        this.icon.appendChild(iconImg);
      }
    });
  }

  change() {
    window.location.href = this.select.value;
  }

  init() {
    this.populate();
    this.select.addEventListener('change', this.change);
  }
}

export default component((node) => {
  (() => new LanguageSelect({ wrapper: node }))();
});
